var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 18.7447C22.5378 14.9921 22.5378 8.91677 18.7852 5.17371",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2144 5.17371C1.46174 8.92637 1.46174 15.0017 5.2144 18.7447",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83252 20.9905C9.85946 21.3456 10.9248 21.5184 11.9997 21.5184C13.0746 21.5088 14.14 21.3456 15.1669 20.9905",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83252 2.92794C9.85946 2.57283 10.9248 2.40002 11.9997 2.40002C13.0746 2.40002 14.14 2.57283 15.1669 2.92794",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80871 12.6911H10.4772V16.5788C10.4772 17.4859 10.9685 17.6695 11.5679 16.9891L15.6553 12.3455C16.1575 11.7786 15.9469 11.3088 15.1856 11.3088H13.5171V7.42118C13.5171 6.51406 13.0257 6.33047 12.4264 7.01081L8.33895 11.6544C7.84219 12.2268 8.05277 12.6911 8.80871 12.6911Z",
    fill: "#F7DE2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyVolt);
export default __webpack_public_path__ + "static/media/icon_my_volt.45666f231987fd73f5183a005f0ff8a3.svg";
export { ForwardRef as ReactComponent };